import {Type} from '@sinclair/typebox'
import {TypeCompiler} from '@sinclair/typebox/compiler'

const schema = Type.Object({
  accountName: Type.String(),
  email: Type.String({
    format: 'email',
  }),
  refCode: Type.Optional(Type.String()),
  id: Type.String(),
})
export type AccountInformation = typeof schema.static

export const accountInformationTypecheck = TypeCompiler.Compile(schema)
